import { IRoute } from "../../../common/helpers/routesMapper";
import injectIntl from "../../../common/helpers/injectIntl";

import { seo } from "../../../common/helpers/seo";

import lazyComponent from "./lazy";

export default {
    component: injectIntl(lazyComponent as any),
    renderSeo: (store: any, allMessage: {[key: string]: string}, lang: string) => {
        return seo({
            title: allMessage["articles.listing.title"],
            description: allMessage["articles.listing.description"],
            allMessage,
            lang,
        });
    },
} satisfies IRoute;
